import { ExActionTree } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";

const actions: ExActionTree<State, Actions, Getters, Mutations> = {};

export default actions;
